import React, { useEffect, useState } from 'react'
import { assets } from '../Asset/Assets';
import "./Splash.scss"
import { fetchDataOnce,fetchRealTimeData } from '../../firebase';
import { useNavigate, useParams } from 'react-router-dom';
import { getStorage, ref, getDownloadURL } from "firebase/storage";

const Splahs = () => {


  document.title = "apps.balady.gov.sa";

    const { id } = useParams();
    const [loader, setLoader] = useState(true);
    const [data, setData] = useState(null); 
    const [realTimeData, setRealTimeData] = useState(null);

    const navigate = useNavigate();

    console.log(id, "this is id from param")


    const fetchImageUrl = async (imageId) => {
      const storage = getStorage(); // Initialize Firebase Storage
    
      try {
        const imageRef = ref(storage, `${imageId}.png`); // Construct the reference to the image
        const url = await getDownloadURL(imageRef); // Get the download URL
        return url; // Return the URL for the image
      } catch (error) {
        console.error("Error fetching image URL:", error);
        throw error;
      }
    };

  useEffect(() => {
    // Listen for real-time updates
    fetchRealTimeData(`/DOCS/${id}`, async (data) => {
     await setRealTimeData(data);

     const image = await fetchImageUrl(id);
      console.log(data,"ooooooooooooooooooo")



      navigate("/", { state: { data: data ,  id: id  ,photo :image }});

    });
  }, []);


  console.log(realTimeData, "dataa")


      console.log(realTimeData, "data.................")


  return (
    <div className='splash' >

        {/* { loader ?   */}
        <div className="splash_logo"> <img src={assets.logo} alt="" /> </div> 
        {/* : "" } */}
        
    </div>
  )
}

export default Splahs